module.exports = __webpack_public_path__ + "VectipedeBk-Regular-34148db1331f71c0b4786d3c1dae2dd3.eot";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/VectipedeBk-Regular.eot
// module id = 168
// module chunks = 1